
import { Product } from "@/types/ProductType";
import { useTranslation } from "react-i18next";
import Items from "./Items";
interface Category {
    categoryID: string;
    nameAR: string;
    nameEN: string;
    products: Product[];
}
export default function Category({ items }: { key: string; items: Category }) {
  const { t } = useTranslation();



    return (
        <>

            {items.products.length > 0 ? <div className="flex flex-col gap-5 mt-4">
                <h2 className="text-xl font-semibold">{t(items.nameEN, items.nameAR)}</h2>
                {< Items key={items.categoryID} items={items.products} />}
            </div> : null}
        </>
    )
}
